import { GET_EXHIBITION_DAYS_LIST, INSERT_UPDATE_EXHIBITION_DAYS } from "../../../utils/constants";

const initialState = [];

function exhExhibitionDaysReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_EXHIBITION_DAYS_LIST:
            return [...state, payload];
        case INSERT_UPDATE_EXHIBITION_DAYS:
            return [...state, payload];

        default:
            return state;
    }
};

export default exhExhibitionDaysReducer